/**
 * @fileoverview GET handler for the "/:app_group_id/messaging_diagnostics/send_outcomes_abort_log" endpoint
 */
import fetch from "@lib/fetch";
import type { Queries } from "@lib/serializeQueryObjects";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementSendOutcomesAbortLogData } from "./constants";
import type { SendOutcomesAbortLogDataParams, SendOutcomesAbortLogDataResult } from "./types";
import { isSendOutcomesAbortLogDataResult } from "./validators";

export const getDataTableEngagementSendOutcomesAbortLogData = reactQueryTableFetcherAdapter(
  engagementSendOutcomesAbortLogData,
  (
    signal: AbortSignal,
    { appGroupId, query = {}, limit = 10, start = 0, skip_count, sortdir = -1 }: SendOutcomesAbortLogDataParams
  ): Promise<SendOutcomesAbortLogDataResult> => {
    return fetch(
      `/${appGroupId}/messaging_diagnostics/send_outcomes_abort_log`,
      "GET",
      {
        limit,
        start,
        skip_count,
        sortdir,
        query: serializeQueryObjects(query as Queries),
      },
      { signal }
    );
  },
  isSendOutcomesAbortLogDataResult
);
